import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import i18n from 'i18n-js';
import {fontFamily} from '../../../helpers/fontFamily';
import RuleEngineDropdown from '../../rulesEngine/RuleEngineDropdown';
import {
  accentColor,
  textColor,
  textInputBg,
  textMutedColor
} from '../../../style/adminTools';

const t = (key, options) => i18n.t(`adminTenantGrid.${key}`, options);

export const ROWS_PER_PAGE = [20, 50, 100];

const PageButton = ({label, onPress, disabled, current, testID}) => (
  <TouchableOpacity
    testID={testID}
    accessibilityRole="button"
    accessibilityState={{disabled, selected: current}}
    disabled={disabled}
    onPress={onPress}
    style={{
      width: 32,
      height: 32,
      marginHorizontal: 2,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 6,
      backgroundColor: current ? accentColor : textInputBg,
      opacity: disabled ? 0.4 : 1
    }}
  >
    <Text
      style={{fontFamily: fontFamily.font600, fontSize: 13, color: textColor}}
    >
      {label}
    </Text>
  </TouchableOpacity>
);

export const pageWindow = (page, pages) => {
  const first = Math.max(1, Math.min(page - 2, pages - 4));
  const last = Math.min(pages, first + 4);
  const numbers = [];
  for (let number = first; number <= last; number += 1) numbers.push(number);
  return numbers;
};

const TenantPager = ({skip, limit, totalCount, gotoPage, onLimitChange}) => {
  const total = totalCount || 0;
  const pages = Math.max(1, Math.ceil(total / limit));
  const page = Math.floor(skip / limit) + 1;
  const textStyle = {
    fontFamily: fontFamily.font500,
    fontSize: 13,
    color: textMutedColor
  };

  return (
    <View
      testID="tenantPager"
      style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 10,
        paddingHorizontal: 12
      }}
    >
      <Text testID="tenantPagerRange" style={textStyle}>
        {total > 0
          ? t('pagerRange', {
              from: skip + 1,
              to: Math.min(skip + limit, total),
              total
            })
          : ''}
      </Text>
      <View style={{flexDirection: 'row', alignItems: 'center'}}>
        <PageButton
          testID="pagerFirst"
          label={'«'}
          disabled={page <= 1}
          onPress={() => gotoPage(1)}
        />
        <PageButton
          testID="pagerPrev"
          label={'‹'}
          disabled={page <= 1}
          onPress={() => gotoPage(page - 1)}
        />
        {pageWindow(page, pages).map(number => (
          <PageButton
            key={number}
            testID={`pagerPage-${number}`}
            label={String(number)}
            current={number === page}
            onPress={() => gotoPage(number)}
          />
        ))}
        <PageButton
          testID="pagerNext"
          label={'›'}
          disabled={page >= pages}
          onPress={() => gotoPage(page + 1)}
        />
        <PageButton
          testID="pagerLast"
          label={'»'}
          disabled={page >= pages}
          onPress={() => gotoPage(pages)}
        />
      </View>
      <View style={{flexDirection: 'row', alignItems: 'center'}}>
        <Text style={{...textStyle, marginRight: 8}}>{t('rowsPerPage')}</Text>
        <View style={{width: 72}}>
          <RuleEngineDropdown
            testID="tenantRowsPerPage"
            accessibilityLabel={t('rowsPerPage')}
            options={ROWS_PER_PAGE.map(size => ({
              value: size,
              label: String(size)
            }))}
            selectedValue={limit}
            onSelect={onLimitChange}
            triggerStyle={{paddingVertical: 3}}
          />
        </View>
      </View>
    </View>
  );
};

export default TenantPager;
